// extracted by mini-css-extract-plugin
module.exports = {"content":"AboutUs_content__VD1YA","container":"AboutUs_container__Hh6Pc","textBlock":"AboutUs_textBlock__S-qeD"};